// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../engine/api/http";
import { roles } from "../../../utils/constants";

const initialState = {
  interpretes: [],
  loading: false,
};

export const getInterpretes = createAsyncThunk(
  "posts/getInterpretesSearch",
  async thunkAPI => {
    const res = await http.get(`/users?role=${roles.interprete}`);
    return res.data.sort((a, b) =>
      a.info.lastname.localeCompare(b.info.lastname),
    );
  },
);

const interpretesSlice = createSlice({
  name: "interpretes",
  initialState,
  reducers: {
    clearInterpretes: state => {
      return initialState;
    },
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
  extraReducers: {
    [getInterpretes.pending]: state => {
      state.loading = true;
    },
    [getInterpretes.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.interpretes = payload;
    },
    [getInterpretes.rejected]: state => {
      state.loading = false;
    },
  },
});

export const { clearInterpretes } = interpretesSlice.actions;

export const interpretesReducer = interpretesSlice.reducer;
